export const API_VERSION = "v1";

export const API_PATHS = {
  health: "/health",
  posts: `/${API_VERSION}/posts`,
  jobs: `/${API_VERSION}/jobs`,
  generate: `/${API_VERSION}/generate`,
} as const;

export const CONTENT_MAX_LENGTH = 20_000;

/** Longest disclaimer line the player will show under itself. */
export const DISCLAIMER_MAX_LENGTH = 160;

export const AUDIO_FORMATS = ["mp3", "ogg", "wav"] as const;
export type AudioFormat = (typeof AUDIO_FORMATS)[number];
